export default "__VITE_ASSET__D$CjuT1z__"